export default {
  'alert-color': 'red',
  'alert-color-hover': 'rgb(179, 0, 0)',
  'success-color': 'rgb(20, 227, 20)',
  white: '#fff',
  black: '#000',
  'white-hover': '#ebebeb',
};
